/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import request from 'modules/common/utils/request';
import { API as ORGANIZATION_API } from 'modules/dashboard/constants';
import { paceActions } from './slice';

/**
 * Get pace data generator function to get organization related data
 * @param {*} param0
 */
export function* getPaceTabularDataGenerator({ payload }) {
  try {
    const response = yield call(request, ORGANIZATION_API.GET_JS_VISUAL_DATA, payload);
    yield put(paceActions.getPaceTabularDataSucceeded(response));
  } catch (error) {
    yield put(paceActions.getPaceTabularDataFailed(error?.message));
  }
}

//
export function* paceSaga() {
  yield takeLatest(paceActions.getPaceTabularData.type, getPaceTabularDataGenerator);
}
//
export default paceSaga;
